import { Navigate } from "react-router-dom";

export default function Apply() {
  return <Navigate to="/membership" replace />;
}
